<template>
  <div class="editor-slider__edit-wrapper">
    <EditorEditButton icon="editor/setting" @click="emit('edit')" />
    <EditorEditButton icon="editor/delete" @click="emit('delete')" />
  </div>
</template>

<script setup>
const emit = defineEmits(['edit', 'delete']);
</script>
